module.exports = __webpack_public_path__ + "static/reviewer_3-014ab1e0e6df6556c9be8c26fd6faa13.png";